import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getProducts = () => api.get("/products").then((r) => r.data);
export const getBundle = () => api.get("/bundle").then((r) => r.data);
export const getProduct = (id) => api.get(`/products/${id}`).then((r) => r.data);
export const subscribe = (email) => api.post("/subscribe", { email }).then((r) => r.data);
export const sendContact = (data) => api.post("/contact", data).then((r) => r.data);
export const checkout = (payload) => api.post("/payments/checkout", payload).then((r) => r.data);
export const donate = (amount, origin_url) => api.post("/payments/donate", { amount, origin_url }).then((r) => r.data);
export const paymentStatus = (sid) => api.get(`/payments/status/${sid}`).then((r) => r.data);

export const registerUser = (data) => api.post("/auth/register", data).then((r) => r.data);
export const loginUser = (data) => api.post("/auth/login", data).then((r) => r.data);
export const getMe = (token) => api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

const authHeader = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("cs_token") || ""}` } });
export const adminStats = () => api.get("/admin/stats", authHeader()).then((r) => r.data);
export const adminAnalytics = () => api.get("/admin/analytics", authHeader()).then((r) => r.data);
export const adminOrders = () => api.get("/admin/orders", authHeader()).then((r) => r.data);
export const adminAccounts = () => api.get("/admin/accounts", authHeader()).then((r) => r.data);
export const adminMessages = () => api.get("/admin/messages", authHeader()).then((r) => r.data);

function visitorId() {
  let id = localStorage.getItem("cs_vid");
  if (!id) { id = (crypto?.randomUUID?.() || String(Date.now() + Math.random())); localStorage.setItem("cs_vid", id); }
  return id;
}
export const trackVisit = (path) =>
  api.post("/track", { path, visitor_id: visitorId(), referrer: document.referrer || "direct" }).catch(() => {});
